module.exports = __webpack_public_path__ + "static/media/edit-icon.f491175e.svg";